import { getHooksForCompany } from '../store/apis/helper/apiHelpers';

const useFetchAppointments = (selectedCompany, hnAppointmentId, from, to, open) => {
    if (!selectedCompany) {
        return { data: [], isLoading: true, error: null };
    }
    const apiHooks = getHooksForCompany(selectedCompany);

    if (!apiHooks) {
        return { data: null, isLoading: false, error: 'API hooks not found' };
    }
    

    const appointmentQuery = apiHooks.useFetchAppointmentsQuery({
        hnAppointmentId, from, to, open
    });
    
    const isLoading = appointmentQuery.isLoading;
    const error = appointmentQuery.error;
    const formattedData = isLoading || error ? null : appointmentQuery.data || [];

    return { data: formattedData, isLoading, error };
};

export default useFetchAppointments;
